(function () {
  var rootSelector = "[data-hj-product-trust-tabs]";
  var tabSelector = "[data-hj-trust-tab]";
  var cardSelector = "[data-hj-trust-card]";
  var panelSelector = "[data-hj-trust-panel]";

  function initTrustTabs(root) {
    if (!root || root.dataset.hjProductTrustTabsReady === "true") {
      return;
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll(tabSelector));
    var card = root.querySelector(cardSelector);
    var panels = Array.prototype.slice.call(root.querySelectorAll(panelSelector));

    if (!tabs.length || !panels.length) {
      return;
    }

    root.dataset.hjProductTrustTabsReady = "true";

    function deactivateTabs(shouldFocus) {
      if (card) {
        card.hidden = true;
      }

      tabs.forEach(function (item) {
        item.setAttribute("aria-selected", "false");
        item.setAttribute("aria-expanded", "false");
        item.tabIndex = 0;
      });

      panels.forEach(function (panel) {
        panel.hidden = true;
      });

      if (shouldFocus && shouldFocus.focus) {
        shouldFocus.focus();
      }
    }

    function activateTab(tab, shouldFocus) {
      var panelId = tab.getAttribute("aria-controls");

      if (card) {
        card.hidden = false;
      }

      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.setAttribute("aria-selected", isActive ? "true" : "false");
        item.setAttribute("aria-expanded", isActive ? "true" : "false");
        item.tabIndex = 0;
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.id !== panelId;
      });

      if (shouldFocus) {
        tab.focus();
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        if (tab.getAttribute("aria-selected") === "true") {
          deactivateTabs(false);
          return;
        }

        activateTab(tab, false);
      });

      tab.addEventListener("keydown", function (event) {
        var nextIndex = index;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    tabs.forEach(function (tab) {
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("aria-expanded", "false");
      tab.tabIndex = 0;
    });

    panels.forEach(function (panel) {
      panel.hidden = true;
    });

    if (card) {
      card.hidden = true;
    }
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(rootSelector), initTrustTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
